import { createLazyComponent, LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AddCalendarsPane"*/ './lazyIndex')
);

// Lazy Actions
export const lazyOpenAddCalendarsPane = new LazyAction(lazyModule, m => m.openAddCalendarsPane);
export const lazyHideAddCalendarsPane = new LazyAction(lazyModule, m => m.hideAddCalendarsPane);
export const lazyNavigateToAddCalendarPanel = new LazyAction(
    lazyModule,
    m => m.navigateToAddCalendarPanel
);
export const lazySetAndNavigateWebImport = new LazyAction(
    lazyModule,
    m => m.setAndNavigateWebImport
);
export const lazySetAndNavigateFileImport = new LazyAction(
    lazyModule,
    m => m.setAndNavigateFileImport
);

// Lazy Selectors
export const lazyGetIsDialogOpen = new LazyImport(lazyModule, m => m.getIsDialogOpen);

// Lazy-load components
export const AddCalendarsPane = createLazyComponent(lazyModule, m => m.AddCalendarsPane);

// Types
export { default as AddCalendarsMenuItemId } from './store/schema/AddCalendarsMenuItemId';
export type { AddCalendarsSource } from './store/schema/AddCalendarsSource';
